<template>
    <div class="sup-tool-module-comp">
        <div class="re-w1200 re-main-col">
            <div class="top-box">
                <span class="top-title">配套工具帮助您快速上手使用</span>
                <span class="top-dis">从文件管理到数据转换、二次开发，提供一整套完善的解决方案</span>
            </div>
            <div class="tool-box">
                <div class="tool-item-box" @click="jump_plugin_click">
                    <img src="@/assets/imgs/product/icon_plugin.png" alt="" />
                    <span>虫洞数据处理引擎</span>
                </div>
                <div class="tool-item-box" @click="jump_platform_click">
                    <img src="@/assets/imgs/product/icon_platform.png" alt="" />
                    <span>自动转换平台</span>
                </div>
                <div class="tool-item-box" @click="jump_sdk_click">
                    <img src="@/assets/imgs/product/icon_sdk.png" alt="" />
                    <span>二次开发SDK</span>
                </div>
            </div>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref } from 'vue';
import { useRouterStore } from '@/stores/router';

const router_store = useRouterStore();

// MARK Click 自动转换平台
const jump_platform_click = () => {
    router_store.navigateToGuide({ shareType: 1, treeId: '3a1712f1-f885-b3df-e321-749ea1c50ce7' });
};

// MARK Click 虫洞数据处理引擎
const jump_plugin_click = () => {
    router_store.navigateToToolUseGuide({ shareType: 1, treeId: '3a134709-e005-1237-bc16-5126f034d264' });
};

// MARK Click 二次开发SDK
const jump_sdk_click = () => {
    router_store.navigateToGuide({ shareType: 1, treeId: '3a1712f2-1070-5ece-eb32-f9a807164ea7' });
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-tool-module-comp {
    position: relative;
    display: flex;
    justify-content: center;

    .top-box {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .top-title {
            position: relative;
            font-weight: 400;
            font-size: 44px;
            color: var(--color-main-text-primary);
        }

        .top-dis {
            position: relative;
            margin-top: 20px;
            font-weight: 400;
            font-size: 20px;
            color: var(--color-main-text-secondary);
        }
    }

    .tool-box {
        position: relative;
        margin-top: 66px;
        height: 300px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 75px;

        .tool-item-box {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            transition: transform 0.3s linear; // 添加 transition 属性

            &:hover {
                transform: var(--transform-scale-105);
            }

            img {
                position: relative;
                width: 350px;
                height: 220px;
                flex-shrink: 0;
            }

            span {
                position: relative;
                margin-top: 32px;
                height: 40px;
                font-weight: 500;
                font-size: 27px;
                color: var(--color-main-text-primary);
                line-height: 31px;
            }
        }
    }
}
</style>
